// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"f77b6ee4","21":"179e657f","489":"f33e2388","523":"cdb701d0","560":"3fd67bbb","773":"cc835858"}[chunkId] + ".chunk.js";
};